import { render, staticRenderFns } from "./appImage.vue?vue&type=template&id=3867d868&scoped=true&"
import script from "./appImage.vue.ts?vue&type=script&lang=ts&"
export * from "./appImage.vue.ts?vue&type=script&lang=ts&"
import style0 from "./appImage.vue?vue&type=style&index=0&id=3867d868&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3867d868",
  null
  
)

export default component.exports